<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="col-lg-12">
        <ng-container [formGroup]="parent">
          <ng-container formGroupName="header">
            <div class="row">
              <div class="col-6 col-min-12">
                <div class="form-group has-float-label mb-2">
                  <label class="form-label">Template Name</label>
                  <p-select
                    class=""
                    formControlName="templateId"
                    (change)="onTemplateSelection()"
                    [filter]="true"
                    [showClear]="true"
                    optionLabel="name"
                    optionValue="id"
                    [options]="templates">
                  </p-select>
                </div>
              </div>
              <div class="col-6 col-min-12">
                <div class="form-group has-float-label mb-2">
                  <label class="form-label">Proposal #</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="proposalNumber" />
                </div>
              </div>
              <div class="col-6 col-min-12">
                <div>
                  <div class="form-group has-float-label mb-2">
                    <label class="form-label">Sender</label>
                    <input
                      pInputText
                      jniAutoCompleteBlocker
                      type="text"
                      class="form-control"
                      placeholder=""
                      formControlName="sender" />
                  </div>
                </div>
              </div>
              <div class="col-6 col-min-12 d-flex gap-3">
                <!-- <div class="form-group mb-2 pe-3" *ngIf="false">
          <label class="d-block form-check-label mb-1">Rush</label>
          <input pInputText 
            class="form-check-input m-0 no-bg"
            type="checkbox"
            id="firm1"
            formControlName="rush"
            (click)="onRushSelection($event)"
            (blur)="logValidationErrors()"
          />
        </div> -->
                <div
                  class="form-group-label mt-4 d-flex align-items-center gap-2">
                  <p-checkBox
                    id="firm1"
                    formControlName="revised"
                    (onChange)="onRevisedSelection($event)"
                    [binary]="true"
                    (blur)="logValidationErrors()" />
                  <label class="d-block form-check-label mt-2">Revised</label>
                </div>
                <div class="form-group has-float-label mt-2 col">
                  <label class="form-label">Additional Subject</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    formControlName="additionalSubject"
                    (change)="onAdditionalSubject($event)"
                    (blur)="logValidationErrors()" />
                </div>
              </div>

              <div class="col-6 col-min-12">
                <div class="row">
                  <div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Reply</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        placeholder=""
                        formControlName="reply" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6 col-min-12">
                <div class="form-group has-float-label mb-2">
                  <label class="form-label">Subject</label>
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    class="form-control"
                    placeholder=""
                    formControlName="subject"
                    [disabled]="true"
                    [ngClass]="{ 'has-error': formErrors['subject'] }"
                    (blur)="logValidationErrors()" />

                  <span class="error-msg" *ngIf="formErrors['subject']">
                    {{ formErrors["subject"] }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </p-card>
  </div>
</div>
